import apiPlugin from "./apiPlugin";
import { ApiResponse } from "./../common/interfaces";
import VariablesModel from "../models/Variables/VariablesModel";

export async function GetAllVariables(): Promise<
	ApiResponse<VariablesModel[]>
> {
	return apiPlugin<VariablesModel[]>("GET", "GetAllVariables");
}

export async function AddVariablesDetail(
	variableDetail: VariablesModel
): Promise<ApiResponse<VariablesModel>> {
	return apiPlugin<VariablesModel>(
		"POST",
		"AddNewVariable",
		undefined,
		variableDetail
	);
}

export async function UpdateVariablesDetail(
	variableDetail: VariablesModel
): Promise<ApiResponse<VariablesModel>> {
	return apiPlugin<VariablesModel>(
		"POST",
		"UpdateVariable",
		undefined,
		variableDetail
	);
}

export async function DeleteVariable(
	Name: string,
	CountryId: string
): Promise<ApiResponse<boolean>> {
	return apiPlugin<undefined>(
		"DELETE",
		"DeleteVariable",
		new URLSearchParams({
			Name,
			CountryId,
		}),
		undefined,
		true
	);
}

export async function GetVariableValue(
	Country: string,
	Name: string
): Promise<ApiResponse<string>> {
	return apiPlugin<string>(
		"GET",
		"GetVariableValue",
		new URLSearchParams({
			Country,
			Name,
		}),
		undefined,
		false
	);
}

export async function GetMultipleVariablesValues(
	Country: string,
	Names: string[]
): Promise<ApiResponse<VariablesModel[]>> {
	let params = new URLSearchParams(Names.map((name) => ["Name", name]));
	params.append("Country", Country);
	return apiPlugin<VariablesModel[]>(
		"GET",
		"GetMultipleVariablesValue",
		params,
		undefined,
		false
	);
}

export async function GetMyVariables(
	Country: string
): Promise<ApiResponse<VariablesModel[]>> {
	return apiPlugin<VariablesModel[]>(
		"GET",
		"GetCountryVariables",
		new URLSearchParams({ Country }),
		undefined,
		false
	);
}

export async function GetCountryIdFromName(
	Country: string
): Promise<ApiResponse<number>> {
	return apiPlugin<number>(
		"GET",
		"GetCountryIdFromName",
		new URLSearchParams({ Country }),
		undefined,
		false
	);
}
